import React, { useEffect } from "react";
import Header from "./Header";
import HeaderV2 from "./HeaderV2";
import SideBar from "./SideBar";
import SideBarV2 from "./SideBarV2";
import { myApplicationList } from "../../Store/slice/applicationSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { PORTAL_UI_V2 } from "../../config/uiTheme";

const DefaultLayout = ({ sideBar, setSideBar }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();

  const fetchApplication = async () => {
    try {
      var { data } = await axios.get(`${configData.config.UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
      dispatch(myApplicationList(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchApplication();
  }, []);

  return (
    <>
      {PORTAL_UI_V2 ? (
        <HeaderV2 sideBar={sideBar} setSideBar={setSideBar} />
      ) : (
        <Header sideBar={sideBar} setSideBar={setSideBar} />
      )}
      {PORTAL_UI_V2 ? (
        <SideBarV2 sideBar={sideBar} setSideBar={setSideBar} />
      ) : (
        <SideBar sideBar={sideBar} setSideBar={setSideBar} />
      )}
    </>
  );
};

export default DefaultLayout;
